import { format } from "date-fns";
import { getVariaveisPorContexto } from "./constantes";

export function prepararFiltrosComIntervalo(contexto, filtros, pessoaIds) {
  const filtrosProcessados = { ...filtros };
  const porIntervalo = [];

  if (filtros.dataVencimentoStart && filtros.dataVencimentoEnd) {
    porIntervalo.push({
      coluna: "dataVencimento",
      de: filtros.dataVencimentoStart,
      ate: filtros.dataVencimentoEnd,
    });
  }

  delete filtrosProcessados.dataVencimentoStart;
  delete filtrosProcessados.dataVencimentoEnd;
  filtrosProcessados.porIntervalo = porIntervalo;
  const chavePessoa = obterChavePessoaPorContexto(contexto);
  if (chavePessoa && pessoaIds?.length) {
    filtrosProcessados[chavePessoa] = pessoaIds;
  }
  return filtrosProcessados;
}

function obterChavePessoaPorContexto(contexto) {
  const mapChave = {
    "condicional-cobranca": "pessoaClienteId",
    "condicional-lembrete": "pessoaClienteId",
    "conta-receber-cobranca": "pagadorId",
    "conta-receber-lembrete": "pagadorId",
  };

  return mapChave[contexto];
}

export function prepararCorpoRequisicao(contexto, anexo, pessoasSelecionadas) {
  const body = { contexto };
  if (anexo) {
    body.anexo = anexo;
  }
  if (pessoasSelecionadas?.length) {
    body.pessoaIds = pessoasSelecionadas;
  }
  return body;
}

const valoresPreviewPadrao = {
  apelidoFantasia: "Minha Empresa",
  nomeCompletoCliente: "João Silva",
  primeiroNomeCliente: "João",
  nomeUsuario: "Maria",
  documentosAVencer: [{ valor: 100, dataVencimento: new Date() }],
  condicionais: [
    { codigo: "000123", valor: 450 },
    { codigo: "000124", valor: 120 },
  ],
  titulos: [
    { numeroTitulo: "1234-1", valor: 320 },
    { numeroTitulo: "1234-2", valor: 320 },
  ],
  numeroTitulo: "1234-1, 1234-2",
  valorTitulo: "R$ 640,00",
  dataVencimentoTitulo: format(new Date(), "dd/MM/yyyy"),
  dataAgendamento: format(new Date(), "dd/MM/yyyy"),
  horaAgendamento: format(new Date(), "HH:mm"),
  serieDocumento: "001",
  numeroDocumento: "12345",
  dataPrevistaFechamento: format(new Date(), "dd/MM/yyyy"),
  dataAbertura: format(new Date(), "dd/MM/yyyy"),
  dataFechamento: format(new Date(), "dd/MM/yyyy"),
  status: "Fechado",
  linkPesquisaSatisfacao: "https://example.com/pesquisa",
  linkAgendamento: "https://example.com/agendamento",
  observacoes: "Nenhuma observação",
  ativos:
    "*Ar Condicionado*\n*Marca:* LG\n*Modelo:* Dual Inverter\n*Cor:* Branco",
  nomeServico: "*Limpeza Interna*",
  ativo: "Split LG Dual Inverter",
  dataVencimento: format(new Date(), "dd/MM/yyyy"),
  dataUltimaRecorrencia: format(new Date(), "dd/MM/yyyy"),
  ordemServico: "OS-01",
  quantidadeDias: "60",
  dataNascimento: format(new Date(), "dd/MM"),
  tituloDocumento: "123-1",
  valorTotal: "R$ 100,00"
};

export function previewMensagem(mensagem, contexto, valores = {}) {
  const valoresEfetivos = { ...valoresPreviewPadrao, ...valores };
  const variaveis = getVariaveisPorContexto(
    contexto,
    valores.status || valoresEfetivos.status,
  );
  let preview = mensagem;

  if (variaveis.includes("documentosAVencer")) {
    const documentosFormatados = valoresEfetivos.documentosAVencer
      .map((doc) => {
        const data = new Date(doc.dataVencimento).toLocaleDateString("pt-BR");
        const valor = Number(doc.valor).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return `🔸 Vencimento: ${data} - Valor: ${valor}`;
      })
      .join("\n");
    preview = preview.replace(/\{documentosAVencer\}/g, documentosFormatados);
  }

  if (variaveis.includes("condicionais")) {
    const condicionaisFormatadas = valoresEfetivos.condicionais
      .map((condicional) => {
        const valor = Number(condicional.valor).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return `🔸 Condicional ${condicional.codigo} – ${valor}`;
      })
      .join("\n");
    preview = preview.replace(/\{condicionais\}/g, condicionaisFormatadas);
  }

  if (variaveis.includes("titulos")) {
    const titulosFormatados = valoresEfetivos.titulos
      .map((titulo) => {
        const valor = Number(titulo.valor).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return `🔸 Título ${titulo.numeroTitulo} – ${valor}`;
      })
      .join("\n");
    preview = preview.replace(/\{titulos\}/g, titulosFormatados);
  }

  const variaveisDeLista = ["documentosAVencer", "condicionais", "titulos"];

  variaveis.forEach((variavel) => {
    if (variaveisDeLista.includes(variavel)) return;

    preview = preview.replace(
      new RegExp(`\\{${variavel}\\}`, "g"),
      valoresEfetivos[variavel] || `{${variavel}}`,
    );
  });

  return preview
    .replace(/\*([^*]+?(?:\*[^*]+)*)\*/g, "<strong>$1</strong>")
    .replace(/_([^_]+?(?:_[^_]+)*)_/g, "<em>$1</em>");
}
